import { ClipboardCopyButton } from '@neo/blocks/clipboard-copy-button'
import { useLocation } from 'router-v6'
import { useFlowRunStore } from '../store'
import { AnalysisRenderer } from './analysis-renderer'

const AgentIdDisplay = ({ agentId }: { agentId: string }) => {
  const location = useLocation()
  if (location.pathname.includes('flow-run')) return null
  return (
    <div className="flex items-center justify-between border-b border-border px-1 py-2 gap-2">
      <span className="font-inter text-xs-400 text-secondary min-w-0 break-all">
        Run ID: <span className="font-jetbrains">{agentId}</span>
      </span>
      <ClipboardCopyButton
        textToCopy={agentId}
        className="size-6 shrink-0 text-secondary"
        aria-label="Copy run ID"
        tooltipText="Copy run ID"
        data-testid="button-copy-run-id"
      />
    </div>
  )
}

export const Analysis = () => {
  const { executionHistory, currentRunId } = useFlowRunStore()

  if (executionHistory.length > 0) {
    return (
      <div className="space-y-4 px-2">
        <AgentIdDisplay agentId={currentRunId?.replace('playground.', '') || 'Unknown'} />
        {executionHistory.map((node) => (
          <AnalysisRenderer key={node.timestamp} node={node} />
        ))}
      </div>
    )
  }
  return null
}
